export const ROOT_SCOPE = ':root';
export const DARK_MODE = '[data-theme-mode="dark"]';
export const DATA_THEME_NAMESPACE = 'data-theme-namespace';
export const DATA_THEME_ID = 'data-theme-id';
export var THEME_KEY;
(function (THEME_KEY) {
    THEME_KEY["Colors"] = "colors";
    THEME_KEY["Fonts"] = "fonts";
    THEME_KEY["FontFamily"] = "fontFamily";
    THEME_KEY["FontWeight"] = "fontWeight";
    THEME_KEY["Shadow"] = "shadow";
    THEME_KEY["BlurShadow"] = "blurShadow";
})(THEME_KEY || (THEME_KEY = {}));
/**
 * key 对应 ./theme, value 是 tailwind utility
 */
export const themeInfixMap = {
    [THEME_KEY.Colors]: 'background',
    [THEME_KEY.Fonts]: 'text',
    [THEME_KEY.FontFamily]: 'font',
    [THEME_KEY.FontWeight]: 'font',
    [THEME_KEY.Shadow]: 'shadow',
    [THEME_KEY.BlurShadow]: 'blur-shadow',
};
export const KNOWN_SAFELIST = [
    'underline',
    'line-through',
];
export const FIGMA_COLOR_INFIXES = [
    'dark',
    'light',
    'green',
    'yellow',
    'pink',
    'blue',
    'grey',
    'primary',
    'red',
    'background',
    'system',
    'especially',
    'chart',
];
export const NORMAL_PREFIX = '@';
export const STYLUS_PREFIX = '$';
export var AssetsResolveType;
(function (AssetsResolveType) {
    AssetsResolveType["Relative"] = "relative";
    AssetsResolveType["CDN"] = "cdn";
    AssetsResolveType["NodeModule"] = "node_module";
})(AssetsResolveType || (AssetsResolveType = {}));
export const SUFFIX_FORMAT_MAP = {
    '.woff2': 'woff2',
    '.woff': 'woff',
    '.ttf': 'truetype',
    '.otf': 'opentype',
};
